import { render, staticRenderFns } from "./ClientNoteModal.vue?vue&type=template&id=b3cbf44c"
import script from "./ClientNoteModal.vue?vue&type=script&lang=js"
export * from "./ClientNoteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports